import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Hjem', href: isHome ? '#' : '/' },
    { name: 'Ydelser', href: isHome ? '#ydelser' : '/#ydelser' },
    { name: 'Referencer', href: isHome ? '#referencer' : '/#referencer' },
    { name: 'Om os', href: '/om-os' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${(!isHome || isScrolled) ? 'bg-slate-950/95 backdrop-blur-md border-b border-emerald-900/30' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center group shrink-0">
            <img 
              src="https://assets.auxodev.dk/assets/edaf948a-4a1a-4ebb-aa02-f27510a0c213/img-dbc532a3-2273-4dd3-92e4-7aeeba04b09c-v3.png" 
              alt="Green Energy Consulting Logo" 
              className="h-10 md:h-12 w-auto object-contain" 
            />
          </Link>

          <div className="hidden md:flex items-center md:gap-4 lg:gap-8">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.href} 
                className="text-slate-300 hover:text-emerald-400 md:text-xs lg:text-sm font-medium transition-colors whitespace-nowrap"
              >
                {link.name}
              </Link>
            ))}
            <Link to="/#kontakt" className="bg-white text-slate-900 md:px-4 lg:px-6 py-2 md:text-xs lg:text-sm font-bold rounded-none hover:bg-emerald-50 transition-colors whitespace-nowrap">Kontakt os</Link>
          </div>

          <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-slate-950 border-b border-emerald-900/30 px-4 py-6 space-y-4">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.href} 
              className="block text-slate-300 text-lg" 
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Link to="/#kontakt" className="block text-emerald-400 text-lg font-bold" onClick={() => setIsOpen(false)}>Kontakt os</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
